import { Component, OnInit, OnDestroy } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { Subscription } from 'rxjs';
import Job from 'src/app/interfaces/Event';
import { JobService } from 'src/app/services/job.service';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-jobs',
  templateUrl: './jobs.component.html',
  styleUrls: ['./jobs.component.scss'],
})
export class JobsComponent implements OnInit, OnDestroy {
  subscriptions: Subscription = new Subscription();
  jobs;
  filteredJobs;
  currentUser;
  locked = false;
  params = null;

  constructor(
    private route: ActivatedRoute,
    private userService: UserService,
    private jobService: JobService,
    private analyticsService: AnalyticsService
  ) {}

  ngOnInit() {
    this.analyticsService.event('job_view');
    this.subscriptions.add(
      this.jobService.getJobs().subscribe((jobsRes) => {
        this.jobs = jobsRes.filter((j) => !j.archived);
        this.filteredJobs = this.jobs;
      })
    );
    this.subscriptions.add(
      this.userService.user.subscribe((u) => {
        if (u && u.uid) {
          this.currentUser = u;
          this.locked = false;
        } else {
          this.locked = true;
        }
      })
    );

  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  filterChange(f) {
    this.filteredJobs = f.filteredList;
  }
}
